export default "__VITE_ASSET__Drt9ephu__"